import { z } from 'zod'

export const PaymentItemSchema = z.object({
  id: z.number(),
  provider_item_id: z.number(),
  payment_id: z.number(),
  price: z.number(),
  quantity: z.number(),
  provider_item_name: z.string(),
  provider_item: z.object({
    id: z.number(),
    name: z.string(),
    image: z.string(),
  }),
})

export type PaymentItem = z.infer<typeof PaymentItemSchema>
